import { render, staticRenderFns } from "./DocumentsCard.vue?vue&type=template&id=b7bb0170&scoped=true"
import script from "./DocumentsCard.vue?vue&type=script&lang=js"
export * from "./DocumentsCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCard.vue?vue&type=style&index=0&id=b7bb0170&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bb0170",
  null
  
)

export default component.exports